// Shopify-scoped About Us interactions. Generated from static About Us package.
(function () {
  const aboutRoot = document.querySelector('.ph-about');
  if (!aboutRoot) return;

const footprintRegions = [
  {
    id: "north-america",
    label: "North America",
    coordinates: [-98, 39],
    x: 27.74,
    y: 22.57,
    countries: [],
    intro: "North America is retained as a confirmed market footprint on the source Our Footprints map, supporting the brand's international coverage narrative across mature architectural and renovation markets.",
    projects: []
  },
  {
    id: "south-america",
    label: "South America",
    coordinates: [-55, -15],
    x: 36.14,
    y: 60.64,
    countries: [],
    intro: "South America is shown as a regional footprint on the source map, extending the brand's project presence into southern-hemisphere building and renovation markets.",
    projects: []
  },
  {
    id: "europe",
    label: "Europe",
    coordinates: [10, 51],
    x: 51.85,
    y: 15.38,
    countries: ["Poland", "Czech Republic", "Germany", "Switzerland"],
    intro: "European coverage includes exhibition halls, hotels, restaurants and embassy or consular projects across Poland, Czech Republic, Germany and Switzerland, reflecting flexible stone use in refined public and hospitality spaces.",
    projects: [
      "Poland: Parkview Exhibition Hall",
      "Czech Republic: Karlovy Vary Golf Resort",
      "Czech Republic: HYATT CENTRIC Hotel",
      "Czech Republic: Czech Exhibition Hall",
      "Czech Republic: Prague Restaurant",
      "Germany: Consulate-General of China in Munich",
      "Germany: Germany Exhibition Hall",
      "Switzerland: Chinese Embassy in Bern"
    ]
  },
  {
    id: "russia",
    label: "Russia",
    coordinates: [100, 61],
    x: 68.60,
    y: 10.18,
    countries: ["Russia"],
    intro: "Russia projects include villas, hotel, restaurant and cafe applications, suggesting flexible stone use for cold-climate leisure, hospitality and premium residential interiors.",
    projects: [
      "Lake Baikal Villa",
      "Eler Restaurant",
      "Mantera Hotel",
      "Oksaka Cafe"
    ]
  },
  {
    id: "china",
    label: "China",
    coordinates: [104, 35],
    x: 73.73,
    y: 25.14,
    countries: ["China"],
    intro: "China is the most project-dense region on the source footprint map, covering hotels, resorts, museums, universities, railway stations, restaurants and commercial spaces across a broad domestic project network.",
    projects: [
      "Hainan Poly Sanya GL Hotel",
      "Yalong Shufeng Yunmei Meijing Pavilion Hotel in Mali",
      "Poly Shanwei Hilton Yilin Hotel",
      "Harong Residence Collection Resort Hotel",
      "Mantera Beijing Intercontinental Hotel",
      "Suzhou Huafeng Yu Yuan",
      "Haikou Ruentong Riverside Garden",
      "Chongqing Poly Tianli No.1 Shanghai Theatre Academy Changlin Road Campus",
      "Fritz Xian Dynasty Ruins Museum",
      "China Resources City Vientiane World in Shenzhen",
      "Foshan Poly Overseas Chinese Town",
      "Yunli Sports Center",
      "Guangzhou Tu Air Restaurant",
      "Guangzhou Oktober Wood-fired Steak Restaurant",
      "Liwan Marriott Hotel",
      "Harbin Fuji Ritz-Carlton Hotel",
      "Xiamen University",
      "Guizhou University",
      "Fuzhou South Railway Station",
      "Guangzhou Elegant Hotel",
      "Shanghai Museum",
      "Guangzhou Xitang Restaurant",
      "Zhanjiang Wyndham Grand Plaza Royale Hotel",
      "Huizhou New York's Day Resort Hotel",
      "Zhuhai Huanyu City Genki Sushi",
      "Chinese Diving Team Sheraton Training Base",
      "Foshan Poly OCT Yunxi Marketing Center",
      "Shijuan Country Garden Top-floor Clubhouse",
      "Foshan Poly Yunshang Villa Cluster",
      "Shijuan Country Garden Songhua Mingzhu",
      "Xi'an Jinto Tang 618 Sales Center",
      "Zhuhai Boifeng Lake Resort Hotel",
      "Nanjing Aoxia Xiake Resort Hotel",
      "Qizhou Qinglong Zhongtian Smart Choice Holiday Inn",
      "Wuxi Grand Hotel",
      "Xi'an Academy of Fine Arts",
      "Xi'an North Railway Station",
      "Chinese Academy of Sciences CSU Center",
      "Institute of Remote Sensing Application",
      "Chinese Academy of Sciences",
      "Wuhan Institute of Virology"
    ]
  },
  {
    id: "japan",
    label: "Japan",
    coordinates: [138, 36],
    x: 81.38,
    y: 24.50,
    countries: ["Japan"],
    intro: "Japan is retained as a confirmed regional footprint from the source map, representing the brand's presence in a design-sensitive market with strong expectations for material quality and detail.",
    projects: []
  },
  {
    id: "middle-east",
    label: "Middle East",
    coordinates: [50, 24],
    x: 61.88,
    y: 32.57,
    countries: ["Qatar", "Saudi Arabia"],
    intro: "Middle East coverage connects Qatar and Saudi Arabia projects including mall, medical, airport and royal villa applications, matching high-end commercial, public and private destination spaces.",
    projects: [
      "Qatar: Villaggio Mall Doha",
      "Qatar: Premium Medical Center",
      "Saudi Arabia: King Abdulaziz International Airport",
      "Saudi Arabia: Royal Villa",
      "Saudi Arabia: Private Villa",
      "Saudi Arabia: --"
    ]
  },
  {
    id: "south-asia",
    label: "South Asia",
    coordinates: [77, 23],
    x: 68.48,
    y: 33.27,
    countries: ["India", "Nepal", "Pakistan"],
    intro: "South Asia coverage includes Nepal, India and Pakistan, with villa, hotel, mall, exhibition and fitness-space projects that show flexible stone across hospitality, residential and commercial interiors.",
    projects: [
      "India: Sheraton Chennai Hotel",
      "India: Omkar Hotel Guwahati",
      "India: Mumbai Teavilla Cafe",
      "India: Mumbai Private Residence Villa",
      "India: Hyderabad My Home Bhooja",
      "India: Mumbai Kurla Phoenix City Mall",
      "India: India Exhibition Hall",
      "Nepal: Private Villa",
      "Pakistan: Dhaka City AFNA Supermarket",
      "Pakistan: Dhaka Residential Building",
      "Pakistan: Islamabad Fitness Club",
      "Pakistan: --"
    ]
  },
  {
    id: "thailand",
    label: "Thailand",
    coordinates: [101, 15],
    x: 75.60,
    y: 37.46,
    countries: ["Thailand"],
    intro: "Southeast Asia projects span Thailand, Malaysia, Singapore and Indonesia, including hotels, commercial centers, restaurants, shopping centers and public projects in warm-climate urban markets.",
    projects: [
      "Thailand: Amari Nis Lert Bangkok",
      "Thailand: One Bangkok Commercial Center",
      "Thailand: Bangkok Furniture Club Exhibition Hall"
    ]
  },
  {
    id: "malaysia",
    label: "Malaysia",
    coordinates: [102, 4],
    x: 76.17,
    y: 45.18,
    countries: ["Malaysia"],
    intro: "Southeast Asia projects span Thailand, Malaysia, Singapore and Indonesia, including hotels, commercial centers, restaurants, shopping centers and public projects in warm-climate urban markets.",
    projects: [
      "Malaysia: Shangri-La Sandakan Tom Lee Hotel",
      "Malaysia: Taman Desa Sales Center",
      "Malaysia: Kuala Lumpur LRT Station",
      "Malaysia: Hanwha Cube"
    ]
  },
  {
    id: "indonesia",
    label: "Indonesia",
    coordinates: [118, -2],
    x: 79.60,
    y: 51.14,
    countries: ["Indonesia"],
    intro: "Southeast Asia projects span Thailand, Malaysia, Singapore and Indonesia, including hotels, commercial centers, restaurants, shopping centers and public projects in warm-climate urban markets.",
    projects: [
      "Indonesia: Dedicated Airport Reception Hall for the G20 Summit",
      "Indonesia: Marriott Hotel Yogyakarta",
      "Indonesia: Modern Experience Center of Luoyang Hotel",
      "Indonesia: Jakarta Government Agency Project",
      "Indonesia: Seminyak Shangri Shopping Center in Bali",
      "Indonesia: Level21 Mall in Bali",
      "Indonesia: Manakora Restaurant in Jakarta",
      "Indonesia: Jordano Cafe in Jakarta",
      "Indonesia: Golf Restaurant",
      "Indonesia: Balance Restaurant",
      "Indonesia: MIO Japanese Cuisine Restaurant",
      "Indonesia: Bolehm Flowershop Restaurant in Jakarta",
      "Indonesia: Riverside Japanese Cuisine Restaurant in Jakarta",
      "Indonesia: ABW Restaurant in Jakarta",
      "Indonesia: da Food Court",
      "Indonesia: Laelyana Restaurant",
      "Indonesia: Menara Restaurant in Semarang",
      "Indonesia: Savera Koga in Semarang",
      "Indonesia: Hope KCM Mall in Semarang",
      "Indonesia: Periti Daima Park in Padang",
      "Indonesia: Sambal Heott Marketing Gallery",
      "Indonesia: Automobile Gallery in the Central Business District SIA Firm in Jakarta",
      "Indonesia: GoWork Co-working Space",
      "Indonesia: Babuhaho Primary School",
      "Indonesia: Urban Apartment Building",
      "Indonesia: Hula Villa",
      "Indonesia: Private Villa",
      "Indonesia: Holiday Villa"
    ]
  }
];

const footprintI18n = window.PH_ABOUT_MAP_I18N || {};
function footprintText(key, fallback) {
  return footprintI18n.controls?.[key] || fallback;
}
function footprintRegionDisplay(region) {
  const translated = footprintI18n.regions?.[region.id] || {};
  const countryNames = footprintI18n.countries || {};
  return {
    label: translated.label || region.label,
    intro: translated.intro || region.intro,
    countries: region.countries.map((country) => countryNames[country] || country),
    projects: region.projects.map((project) => project.replace(/^([^:]+):/, (prefix, country) =>
      countryNames[country] ? `${countryNames[country]}:` : prefix))
  };
}
function footprintRegionText(key, fallback, label) {
  return footprintText(key, fallback).replace('__PH_REGION__', label);
}

const footprintRegionById = new Map(footprintRegions.map((region) => [region.id, region]));

const footprintMapStage = document.querySelector(".footprint-map");
const footprintMapGraphic = document.querySelector(".footprint-world-map");
const footprintPinLayer = document.querySelector("[data-footprint-pin-layer]");
const footprintInfo = document.querySelector(".footprint-info");
const footprintCases = document.querySelectorAll(".footprint-case");
const footprintInfoClose = document.querySelector(".footprint-info-close");
let activeRegionId = null;
let lockedRegionId = null;
let footprintCloseTimer = null;
const FOOTPRINT_DEBUG = false;

function canHoverFootprints() {
  return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
}

function clearFootprintCloseTimer() {
  if (!footprintCloseTimer) return;
  window.clearTimeout(footprintCloseTimer);
  footprintCloseTimer = null;
}

function scheduleFootprintClose() {
  clearFootprintCloseTimer();
  if (lockedRegionId) return;
  footprintCloseTimer = window.setTimeout(() => {
    if (!lockedRegionId) hideFootprintInfo();
  }, 280);
}

function escapeFootprintHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function getFootprintRenderedMapRect() {
  if (!footprintMapStage || !footprintMapGraphic) return null;
  const stageRect = footprintMapStage.getBoundingClientRect();
  const graphicRect = footprintMapGraphic.getBoundingClientRect();

  // The SVG viewBox is 1200 × 560 with preserveAspectRatio="xMidYMid meet".
  // The rendered map can be letterboxed inside the <object>. Use the actual
  // rendered SVG viewport so pins, hover hit-area and popup anchor share one coordinate system.
  const viewBoxRatio = 1200 / 560;
  const graphicRatio = graphicRect.width / graphicRect.height;
  let width = graphicRect.width;
  let height = graphicRect.height;
  let left = graphicRect.left;
  let top = graphicRect.top;

  if (graphicRatio > viewBoxRatio) {
    height = graphicRect.height;
    width = height * viewBoxRatio;
    left = graphicRect.left + (graphicRect.width - width) / 2;
  } else {
    width = graphicRect.width;
    height = width / viewBoxRatio;
    top = graphicRect.top + (graphicRect.height - height) / 2;
  }

  return {
    left: left - stageRect.left,
    top: top - stageRect.top,
    width,
    height
  };
}

function syncFootprintPinLayer() {
  if (!footprintMapStage || !footprintMapGraphic || !footprintPinLayer) return;
  const mapRect = getFootprintRenderedMapRect();
  if (!mapRect || !Number.isFinite(mapRect.width) || !Number.isFinite(mapRect.height)) return;
  footprintPinLayer.style.left = `${mapRect.left}px`;
  footprintPinLayer.style.top = `${mapRect.top}px`;
  footprintPinLayer.style.width = `${mapRect.width}px`;
  footprintPinLayer.style.height = `${mapRect.height}px`;
}

function createFootprintPins() {
  if (!footprintPinLayer) return;
  footprintPinLayer.replaceChildren();
  footprintRegions.forEach((region) => {
    const pin = document.createElement("button");
    pin.className = "footprint-pin";
    pin.type = "button";
    pin.dataset.regionId = region.id;
    pin.setAttribute("aria-label", footprintRegionText("open_region", "Open __PH_REGION__ project summary", footprintRegionDisplay(region).label));
    pin.style.left = `${region.x}%`;
    pin.style.top = `${region.y}%`;
    footprintPinLayer.appendChild(pin);
    bindFootprintPin(pin);
  });
}

function getFootprintAnchorPoint(trigger) {
  const mapRect = footprintMapStage?.getBoundingClientRect();
  if (!mapRect) return null;

  const rect = trigger?.getBoundingClientRect?.();
  if (!rect) return { x: mapRect.width / 2, y: mapRect.height / 2 };
  return {
    x: rect.left - mapRect.left + rect.width / 2,
    y: rect.top - mapRect.top + rect.height / 2
  };
}

function positionFootprintInfo(trigger) {
  if (!footprintInfo || !footprintMapStage || window.matchMedia("(max-width: 700px)").matches) {
    footprintInfo?.style.removeProperty("left");
    footprintInfo?.style.removeProperty("top");
    return;
  }

  syncFootprintPinLayer();
  const anchor = getFootprintAnchorPoint(trigger);
  const mapRect = footprintMapStage.getBoundingClientRect();
  if (!anchor) return;

  footprintInfo.style.left = "0px";
  footprintInfo.style.top = "0px";
  const panelRect = footprintInfo.getBoundingClientRect();
  const gap = 18;
  const pad = 18;
  let left = anchor.x + gap;
  let top = anchor.y - Math.min(72, panelRect.height * 0.22);

  if (left + panelRect.width + pad > mapRect.width) {
    left = anchor.x - panelRect.width - gap;
  }
  if (top + panelRect.height + pad > mapRect.height) {
    top = mapRect.height - panelRect.height - pad;
  }
  if (top < pad) top = pad;
  if (left < pad) left = pad;

  footprintInfo.style.left = `${Math.round(left)}px`;
  footprintInfo.style.top = `${Math.round(top)}px`;
}

function renderFootprintRegion(regionId, trigger) {
  if (!footprintInfo || !footprintRegionById.has(regionId)) return;
  clearFootprintCloseTimer();
  const region = footprintRegionById.get(regionId);
  const display = footprintRegionDisplay(region);
  activeRegionId = regionId;

  document.querySelectorAll(".footprint-pin").forEach((pin) => {
    pin.classList.toggle("is-active", pin.dataset.regionId === regionId);
  });

  footprintInfo.querySelector(".info-kicker").textContent = footprintText("summary", "Regional Project Summary");
  footprintInfo.querySelector("h3").textContent = display.label;
  const summary = footprintInfo.querySelector(".footprint-info-summary");
  summary.textContent = display.intro;
  summary.dataset.footprintSummary = display.intro;
  const groups = footprintInfo.querySelector(".footprint-region-groups");
  const countriesText = display.countries.length ? `<p class="footprint-covered">${escapeFootprintHtml(footprintText("covered_countries", "Covered Countries:"))} ${escapeFootprintHtml(display.countries.join(", "))}</p>` : "";
  const projectsHtml = display.projects.length
    ? `<p class="footprint-projects-title">${escapeFootprintHtml(footprintText("projects", "Projects"))}</p><ul>${display.projects.map((item) => `<li>${escapeFootprintHtml(item)}</li>`).join("")}</ul>`
    : "";
  groups.innerHTML = `${countriesText}${projectsHtml}`;
  footprintInfo.querySelector("a").setAttribute("aria-label", footprintRegionText("view_cases", "View editable __PH_REGION__ case list", display.label));
  footprintInfo.setAttribute("aria-hidden", "false");
  footprintInfo.classList.add("is-visible");
  positionFootprintInfo(trigger);
  footprintCases.forEach((item) => {
    const visible = item.dataset.region === region.label || item.dataset.region === "Editable";
    item.classList.toggle("is-muted", !visible);
  });
}

function hideFootprintInfo() {
  activeRegionId = null;
  lockedRegionId = null;
  clearFootprintCloseTimer();
  footprintInfo?.classList.remove("is-visible");
  footprintInfo?.setAttribute("aria-hidden", "true");
  footprintInfo?.style.removeProperty("left");
  footprintInfo?.style.removeProperty("top");
  document.querySelectorAll(".footprint-pin").forEach((pin) => pin.classList.remove("is-active"));
  footprintCases.forEach((item) => item.classList.remove("is-muted"));
}

function bindFootprintPin(pin) {
  pin.addEventListener("mouseenter", () => {
    if (!canHoverFootprints()) return;
    if (lockedRegionId) return;
    renderFootprintRegion(pin.dataset.regionId, pin);
  });
  pin.addEventListener("mouseleave", scheduleFootprintClose);
  pin.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    lockedRegionId = pin.dataset.regionId;
    renderFootprintRegion(pin.dataset.regionId, pin);
  });
  pin.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    lockedRegionId = pin.dataset.regionId;
    renderFootprintRegion(pin.dataset.regionId, pin);
  });
}

footprintInfoClose?.addEventListener("click", (event) => {
  event.preventDefault();
  hideFootprintInfo();
});
footprintInfo?.addEventListener("mouseenter", clearFootprintCloseTimer);
footprintInfo?.addEventListener("mouseleave", scheduleFootprintClose);

// Localize controls without changing map coordinates, region IDs or case filter labels.
footprintMapStage?.setAttribute("aria-label", footprintText("map_label", "Editable global project coverage map"));
footprintMapGraphic?.setAttribute("aria-label", footprintText("world_map_label", "World countries map based on Natural Earth 50m Admin 0 Countries"));
footprintPinLayer?.setAttribute("aria-label", footprintText("pins_label", "Clickable project regions"));
footprintInfoClose?.setAttribute("aria-label", footprintText("close", "Close region information"));
if (footprintInfo) {
  if (footprintI18n.direction === "rtl") footprintInfo.dir = "rtl";
  footprintInfo.querySelector(".info-kicker").textContent = footprintText("summary", "Regional Project Summary");
  footprintInfo.querySelector("h3").textContent = footprintText("initial_region", "Project Region");
  footprintInfo.querySelector(".footprint-info-summary").textContent = footprintText("initial_summary", "Click a region point to view a regional project overview and representative project list from the source footprint map.");
  footprintInfo.querySelector(".footprint-region-groups").setAttribute("aria-label", footprintText("projects_label", "Representative projects"));
  const projectTitle = footprintInfo.querySelector(".footprint-projects-title");
  if (projectTitle) projectTitle.textContent = footprintText("projects", "Projects");
  const casesLink = footprintInfo.querySelector("a");
  casesLink.textContent = footprintText("view_related_cases", "View Related Cases");
  casesLink.setAttribute("aria-label", footprintText("related_case_label", "View related case list"));
}

createFootprintPins();
syncFootprintPinLayer();
if (FOOTPRINT_DEBUG) footprintMapStage?.classList.add("is-debug");
window.addEventListener("load", syncFootprintPinLayer);
window.addEventListener("resize", () => {
  syncFootprintPinLayer();
  if (activeRegionId) {
    const activePin = document.querySelector(`.footprint-pin[data-region-id="${activeRegionId}"]`);
    if (activePin) positionFootprintInfo(activePin);
  }
});
footprintMapGraphic?.addEventListener("load", syncFootprintPinLayer);

window.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && activeRegionId) hideFootprintInfo();
});

document.querySelector(".footprint-map")?.addEventListener("click", (event) => {
  if (!lockedRegionId) return;
  if (event.target.closest(".footprint-info")) return;
  if (event.target.closest(".footprint-pin")) return;
  if (event.target.closest(".footprint-world-map")) return;
  hideFootprintInfo();
});

document.querySelector(".footprints")?.addEventListener("click", (event) => {
  if (!lockedRegionId) return;
  if (event.target.closest(".footprint-info")) return;
  if (event.target.closest(".footprint-pin")) return;
  if (event.target.closest(".footprint-world-map")) return;
  hideFootprintInfo();
});

document.addEventListener("click", (event) => {
  if (!lockedRegionId) return;
  if (event.target.closest(".footprint-info")) return;
  if (event.target.closest(".footprint-pin")) return;
  hideFootprintInfo();
});



(() => {
      const cards = document.querySelectorAll(".timeline article");
      if (!cards.length) return;

      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reducedMotion || !("IntersectionObserver" in window)) {
        cards.forEach((card) => card.classList.add("timeline-card-visible"));
        return;
      }

      const observer = new IntersectionObserver((entries, timelineObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("timeline-card-visible");
          timelineObserver.unobserve(entry.target);
        });
      }, {
        root: null,
        rootMargin: "0px 0px -12% 0px",
        threshold: .24
      });

      cards.forEach((card) => observer.observe(card));
    })();
})();

